import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useRef, useContext, useEffect } from 'react';
import { Popup, Button } from 'semantic-ui-react';
import _isNil from 'lodash/isNil';
import { v4 as uuidv4 } from 'uuid';
import { DEFAULT_CLASS_NAME, DEFAULT_DESKTOP_PROPS } from './AccordionsPopup.constants';
import { getPopupOffset } from './AccordionsPopup.utils';
import useResponsive from '../../../../../../../../hooks/use-responsive/use-responsive';
import { SiteNavigationLinkGroupsPropType, SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import { classNames } from '../../../../../../../../utils/classname';
import { listenToStyleDomChanges } from '../../../../../../../../utils/dom';
import Icon from '../../../../../../../foundation/components/Icon/Icon';
import useEventListener from '../../../../../../../foundation/hooks/use-event-listener/use-event-listener';
import { isRefClicked } from '../../../../../../../foundation/services/dom';
import { PopupUtils } from '../../../../../../../foundation/services/popup';
import { NavigationContext } from '../../../../Navigation.context';
import BaseLink from '../../../Link';
import { ITEM_NAVIGATION_MODE } from '../../PopupAccordionMenuLink.constants';
import { NavigationModePropType } from '../../PopupAccordionMenuLink.types';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import PopupContent from '../PopupContent';
import './AccordionsPopup.less';
var defaultProps = {
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  desktop: DEFAULT_DESKTOP_PROPS,
  initialActiveIndices: [],
  targetPositionId: '',
  navigationMode: ITEM_NAVIGATION_MODE
};
export default function AccordionsPopup(_ref) {
  var _classNames;
  var parentLink = _ref.parentLink,
    links = _ref.links,
    maxLinksToShow = _ref.maxLinksToShow,
    desktop = _ref.desktop,
    initialActiveIndices = _ref.initialActiveIndices,
    targetPositionId = _ref.targetPositionId,
    navigationMode = _ref.navigationMode;
  var uuid = useRef(uuidv4());
  var _DEFAULT_DESKTOP_PROP = _objectSpread(_objectSpread({}, DEFAULT_DESKTOP_PROPS), desktop),
    desktopFullScreen = _DEFAULT_DESKTOP_PROP.fullScreen;
  var _useResponsive = useResponsive(),
    isDesktop = _useResponsive.isDesktop,
    isTouchScreenDevice = _useResponsive.isTouchScreenDevice;
  var triggerRef = useRef(null);
  var contentRef = useRef(null);
  var observerRef = useRef(null);
  var _useContext = useContext(NavigationContext),
    toggled = _useContext.toggled,
    openedAccordionPopups = _useContext.openedAccordionPopups,
    setOpenedAccordionPopups = _useContext.setOpenedAccordionPopups,
    setOpenedDropdownMenus = _useContext.setOpenedDropdownMenus;
  var showPopup = openedAccordionPopups.includes(uuid.current);
  function toggleShowPopup() {
    setOpenedAccordionPopups(function (previousOpened) {
      return previousOpened.includes(uuid.current) ? previousOpened.filter(function (popupUuid) {
        return popupUuid !== uuid.current;
      }) : [uuid.current];
    });
    if (showPopup) {
      setOpenedDropdownMenus([]);
    }
  }
  function displayPopup() {
    setOpenedAccordionPopups([uuid.current]);
    setOpenedDropdownMenus([]);
  }
  function hidePopup() {
    setOpenedAccordionPopups(function (previousOpened) {
      return previousOpened.filter(function (popupUuid) {
        return popupUuid !== uuid.current;
      });
    });
  }
  function clickedOnPopupTrigger(event) {
    return isRefClicked(triggerRef, event);
  }
  function clickedOnPopupContent(event) {
    return isRefClicked(contentRef, event);
  }
  useEffect(function () {
    if (!toggled) {
      // make sure the popup is closed when the tray is closed
      hidePopup();
    }
  }, [toggled]);
  useEventListener('click', function (event) {
    if (!clickedOnPopupContent(event) && !clickedOnPopupTrigger(event)) {
      hidePopup();
    }
  });
  function onParentTransformChange() {
    if (isDesktop && desktopFullScreen) {
      PopupUtils.makePopupFullWidth(document.querySelector(".".concat(DEFAULT_CLASS_NAME)));
    }
  }
  function onPopupMount() {
    var component = document.querySelector(".".concat(DEFAULT_CLASS_NAME));
    var parentElement = component.parentNode;
    observerRef.current = listenToStyleDomChanges(parentElement, onParentTransformChange);
  }
  function onPopupUnmount() {
    observerRef.current.disconnect();
  }
  function onMouseEnterPopupTrigger() {
    if (isTouchScreenDevice) {
      return;
    }
    displayPopup();
  }
  var title = parentLink.title,
    url = parentLink.url,
    slug = parentLink.slug,
    pageType = parentLink.pageType,
    as = parentLink.as,
    className = parentLink.className;
  var offset = getPopupOffset(triggerRef, targetPositionId, isDesktop);
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_CLASS_NAME, true), _defineProperty(_classNames, "offset", !_isNil(offset)), _classNames));
  return /*#__PURE__*/React.createElement(Popup, {
    className: finalClassName,
    open: showPopup,
    flowing: true,
    offset: offset,
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "trigger-container",
      ref: triggerRef
    }, /*#__PURE__*/React.createElement(BaseLink, {
      title: title,
      url: url,
      slug: slug,
      type: pageType.toLowerCase(),
      as: as,
      className: className
    }), /*#__PURE__*/React.createElement(Button, {
      icon: true,
      className: "trigger",
      onClick: toggleShowPopup,
      "aria-label": "Toggle menu",
      onMouseEnter: onMouseEnterPopupTrigger
    }, /*#__PURE__*/React.createElement(Icon, {
      iconName: showPopup ? 'xmark' : 'angle-down'
    }))),
    content: /*#__PURE__*/React.createElement(PopupContent, {
      links: links,
      maxLinksToShow: maxLinksToShow,
      onLinkClick: hidePopup,
      initialActiveIndices: initialActiveIndices,
      containerRef: contentRef,
      onClose: hidePopup,
      navigationMode: navigationMode
    }),
    position: PopupUtils.getSafePosition(triggerRef, {
      position: 'bottom center'
    }),
    onMount: onPopupMount,
    onUnmount: onPopupUnmount
  });
}
AccordionsPopup.defaultProps = defaultProps;